module.exports = __webpack_public_path__ + "img/p_icon04.c6476cce.svg";